import React from 'react';
import { CheckIcon } from 'lucide-react';
import { summaryRows } from '../data/summary';
import { price, productShortName, totalBonuses, totalVolumes } from '../data/offer';
export function SummaryTable() {
  return <section className="bg-blue-950 py-16 sm:py-20" aria-labelledby="summary-title" data-id="element-224" data-mp="o71jkm7hsj9a">
      <div className="mx-auto max-w-4xl px-4" data-id="element-225" data-mp="j7yex2vfcf1u">
        <h2 id="summary-title" className="text-center text-3xl font-extrabold text-white sm:text-4xl" data-id="element-226" data-mp="j53uvcgbow8y">
          Everything included
        </h2>
        <p className="mt-3 text-center text-slate-300" data-id="element-227" data-mp="1bvkqoyet2pzs">
          {productShortName} · {totalVolumes} volumes + {totalBonuses} bonuses ·{' '}
          <b className="text-white" data-id="element-228" data-mp="16uy6xrstigs5">{price}</b>
        </p>

        <ul className="mt-10 grid gap-3 sm:grid-cols-2" data-id="element-229" data-mp="12vxnq86fhc4m">
          {summaryRows.map(([feature, detail]) => <li key={feature} className="flex gap-3 rounded-lg border border-slate-300/20 bg-blue-900/50 p-4" data-id="element-230" data-mp="3rnrtvda3xigs">
              <span className="metal-silver mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full" data-id="element-231" data-mp="3njtv53op29o9">
                <CheckIcon className="h-3.5 w-3.5 text-blue-950" aria-hidden="true" data-id="element-232" data-mp="3iath5ns5j35x" />
              </span>
              <p data-id="element-233" data-mp="3n9wk92okmzb9">
                <b className="block text-sm text-white" data-id="element-234" data-mp="39c7yztqldq5o">{feature}</b>
                <span className="text-sm text-slate-300" data-id="element-235" data-mp="39by7g1pwfaxv">{detail}</span>
              </p>
            </li>)}
        </ul>

        <blockquote className="mx-auto mt-10 max-w-2xl rounded-xl border-l-4 border-slate-300 bg-blue-900 px-6 py-5 text-center text-lg font-bold leading-relaxed text-white" data-id="element-236" data-mp="2zmeo6uy9xf2h">
          “The best time to have these materials was at the start of your year. The second-best time is today.”
        </blockquote>
      </div>
    </section>;
}